import React from "react";

const TemplateSetupForm = ({ 
  selectedCategory, 
  setSelectedCategory, 
  selectedSubCategory, 
  setSelectedSubCategory,
  categories,
  subcategories,
  isSubcategoryDisabled,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-6xl">
      {/* Template Setup Form */}
      <h2 className="text-xl font-semibold mb-2">Set up your template</h2>
      <p className="text-gray-500 text-sm mb-4">
        Choose the category that best describes your message template. Then,
        select the type of message that you want to send.
        <span className="text-blue-500 cursor-pointer">
          {" "}
          Learn more about categories.
        </span>
      </p>

      {/* Category Selection */}
      <div className="flex space-x-2 mb-4">
        {Object.keys(categories).map((category) => {
          const Icon = categories[category].icon;
          return (
            <button
              key={category}
              className={`px-4 py-2 rounded flex-1 text-sm font-semibold flex items-center justify-center gap-2 ${
                selectedCategory === category
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-600 hover:bg-gray-300"
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              <Icon size={16} strokeWidth={2} />
              {category}
            </button>
          );
        })}
      </div>

      {/* Message Type Selection */}
      <div className="bg-gray-50 p-4 rounded-lg mb-6 border w-full">
        {subcategories.map((option) => {
          const isDisabled = isSubcategoryDisabled(selectedCategory, option.label);
          return (
            <div
              key={option.label}
              className={`flex items-start p-3 rounded-md mb-2 ${
                isDisabled
                  ? "opacity-50 "
                  : selectedSubCategory === option.label
                  ? "bg-blue-100 border border-blue-400 cursor-pointer"
                  : "hover:bg-gray-100 cursor-pointer"
              }`}
              onClick={() => !isDisabled && setSelectedSubCategory(option.label)}
            >
              <input
                type="radio"
                name="messageType"
                checked={selectedSubCategory === option.label}
                onChange={() => !isDisabled && setSelectedSubCategory(option.label)}
                disabled={isDisabled}
                className={`mt-1 mr-3 w-5 h-5 accent-blue-600 ${
                  isDisabled ? "cursor-pointer" : "cursor-pointer"
                }`}
              />
              <div>
                <p className="font-medium text-sm">{option.label}</p>
                <p className="text-xs text-gray-500">{option.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TemplateSetupForm;